import { API } from 'config';

function UserService($http) {

  'ngInject';

  return {
    update: (user) => $http.put(API.USER, user),
  };
}

export default UserService;



// WEBPACK FOOTER //
// ./src/services/User.js